import {
  extractAnswerMessageContent,
  InteractionInfo,
  OverlayComponentProps,
} from '$/components/Interactions/InteractionInfo';
import {
  InteractionModalAccordionsHook,
  InteractionModalComponentProps,
} from '$/components/Interactions/types';
import { TimelineComponents } from '$/components/WebinarPlayer/context';
import {
  AttendeeFragment,
  InteractionDetails,
  InteractionForAttendeeFragment,
  InteractionFragment,
  PublicEWebinarFragment,
  ReactionFragment,
} from '$/GraphQL/schema/schema';
import React from 'react';
import { theme } from 'twin.macro';
import CardMain from '../cards/CardMain';
import { AnalyticsCardProps } from '../cards/types';
import { OverlayInteractionInfo } from '../OverlayInteractionInfo';
import ImageOverlayComponent from './ImageOverlayComponent';
import ImageOverlayCard from './ImageOverlayCard';
import { useImageOverlaySettings } from './useImageOverlaySettings';

const AnalyticsImageOverlayCard = React.lazy(() => import('./AnalyticsImageOverlayCard'));
const TipModalCard = React.lazy(() => import('../Tip/TipModal'));

export class ImageOverlayInfo extends OverlayInteractionInfo {
  public constructor(
    i: InteractionForAttendeeFragment | InteractionFragment,
    ewebinar?: PublicEWebinarFragment,
    public attendee?: AttendeeFragment
  ) {
    super(i, ewebinar, attendee);
  }

  public typeName(): string | undefined {
    return 'Image overlay';
  }

  public modalSettingsAccordions(): InteractionModalAccordionsHook | null {
    return useImageOverlaySettings;
  }

  public color(): string | undefined {
    return theme`colors.blue.400`.toString();
  }

  public timelineComponent(): keyof TimelineComponents {
    return 'imageOverlays';
  }

  public onlyExistsInPresentationRoom(): boolean {
    return true;
  }

  public onlyOneInstance(): boolean {
    return false;
  }

  public hasAnswers(): boolean {
    return Boolean(this.fragment.details?.link);
  }

  public isInteractiveCard(): boolean {
    return Boolean(this.fragment.details?.link);
  }

  public hasPropertyNameField(): boolean {
    return false;
  }
  public detailsDefault(_interactions: InteractionInfo[]): InteractionDetails {
    return {
      title: '',
    };
  }

  public hasEngagement(): boolean {
    return Boolean(this.fragment.details?.link);
  }

  public analyticsCardComponent(): React.LazyExoticComponent<React.FC<AnalyticsCardProps>> {
    return AnalyticsImageOverlayCard;
  }

  public renderOverlayComponent(): React.FC<OverlayComponentProps> {
    return ImageOverlayComponent;
  }

  public renderMessageCard(
    reaction: Pick<
      ReactionFragment,
      'stringAnswer' | 'numberAnswer' | 'detailsFields' | 'arrayAnswer'
    >,
    content: string
  ): JSX.Element {
    const { title, answer } = extractAnswerMessageContent(content);

    const cardBody = this.messageCardBody(reaction, answer);

    return <CardMain.InteractionMessageCard interaction={this} title={title} cardBody={cardBody} />;
  }

  public cardComponent(): React.FC<{ onClickHeader?: (() => void) | undefined }> {
    return ImageOverlayCard;
  }

  public useModalPreviewComponent(): React.LazyExoticComponent<
    React.FC<InteractionModalComponentProps>
  > | null {
    return TipModalCard;
  }
}
